// Styles for the shared duel create-game form (rounds / time / who-can-join). Prefix: dcf-.
// Glass tokens with literal fallbacks. Registered in STYLING.md.
export const duelCreateFormStyles = `
.dcf-setup { display: flex; flex-direction: column; gap: var(--space-4, 16px); }
.dcf-setrow { display: flex; flex-direction: column; align-items: center; gap: var(--space-2, 8px); }
.dcf-setlbl {
  font-size: var(--fs-12, 12px);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--catchup-gray, #799ba6);
  text-align: center;
  margin: 0;
}
.dcf-vis { display: flex; gap: var(--space-3, 12px); }
.dcf-viscard {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-1, 4px);
  padding: var(--space-3, 12px) var(--space-4, 16px);
  border: 1px solid var(--glass-border, rgba(120, 180, 200, 0.35));
  border-radius: var(--radius-lg, 16px);
  background: var(--glass-bg-soft, rgba(255, 255, 255, 0.55));
  cursor: pointer;
  text-align: left;
  transition: border-color var(--duration-fast, 150ms) var(--ease-out, ease),
    background var(--duration-fast, 150ms) var(--ease-out, ease);
}
.dcf-viscard.is-on {
  border-color: var(--accent, #57c2d3);
  background: var(--accent-soft, rgba(87, 194, 211, 0.12));
}
.dcf-viscard b { font-size: var(--fs-14, 14px); color: var(--catchup-dark-blue, #0f3b4a); }
.dcf-viscard small { font-size: var(--fs-12, 12px); color: var(--catchup-gray, #799ba6); line-height: 1.35; }
.dcf-visic { font-size: 20px; }
.dcf-setactions { display: flex; justify-content: center; margin-top: var(--space-2, 8px); }

@media (max-width: 560px) {
  .dcf-vis { flex-direction: column; }
}
`;
